const ProviderType = Object.freeze({
    JIRA: 'jira',
    SERVICE_NOW: 'servicenow',
    QUALYS: 'qualys',
    GITHUB: 'github',
    OPENVPN: 'openvpn',
  });
  
  module.exports = ProviderType;